import React from "react";
import './index.css'

const CustomSelector = ({list,visoriaInfo, setVisoriaInfo, keyTarget})=>{
    return(
        <select
        onChange={e =>{
            const target = e.target.value
            const targetFind = list?.find(item => item.name === target)
            setVisoriaInfo(prev => ({...prev, [keyTarget]:{...prev[keyTarget], name: target, code:targetFind?.isoCode}}))
        }}
        
        value={visoriaInfo[keyTarget].name}>
            {
                list?.map((item)=>(
                    <option value={item?.name}>
                        {item?.flag} {item?.name}
                    </option>
                ))
            }
        </select>
        
    )
}

export default CustomSelector